import React from "react";
// import "./BCSection.css";
import { useState, useEffect } from "react";
import { Button, Card, Upload, Spin, message, Empty, Modal, Input } from "antd";
import { BaseUrl, jwtToken, UserName } from "../../Repository/BaseRepository";
import {
  getStatusDumpData,
  callTimecardsGrid,
  downloadAutoCrawledFiles,
} from "../../Repository/TimecardFollowupRepository";
import axios from "axios";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { SuccessMessage ,ErrorMessage} from "../../Utils/Utils";
import {
  downloadBillingAutoCrawledFiles,
  dwnldBillingAutocrawl,
  getBillingMasterfile,
} from "../../Repository/BillingRepository";
import {
  GetSingleClientCreds,
  UpdateClientCredential,
} from "../../Repository/ClientCredentialsRepository";
import {
  GetAutoCrawlStatus,
  Get_ReConsolidation_Client_Header_Data,
} from "../../redux/TimeCardsRedux/TimeCardsActions";
import { useDispatch } from "react-redux";
import { downloadCanadaAutoCrawledFiles } from "../../Repository/CanadaAutoCrawlRepository";
const AutocrawlCanada_Section = ({ autocrawl, setAutoCrawlData }) => {
  const autocrawlData = autocrawl;
  console.log(autocrawl);
  const [buttonLoad, setButtonLoad] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalVisibleFlag, setIsModalVisibleFlag] = useState(false);
  const [ClientData, setClientData] = useState([]);
  const [ModifiedClientData, setModifiedClientData] = useState({});
  const [ModifiedClientsData, setModifiedClientsData] = useState({});
  const [SelectedVms, setSelectedVms] = useState("");
  const [invalidClients, setInvalidClients] = useState([]);
  const [failedClients, setfailedClients] = useState([]);
  const [isInvalidModalVisible, setInvalidModalVisible] = useState(false);
const [isFailedModalVisible, setFailedModalVisible] = useState(false);
  const dispatch = useDispatch();
  const [isCrawling, setIsCrawling] = useState(false);

  useEffect(() => {
    if (autocrawl && autocrawl.InvalidClients) {
      setInvalidClients(autocrawl.InvalidClients);
    }
  }, [autocrawl]);
  useEffect(() => {
    if (autocrawl && autocrawl.FailedClients) {
      setfailedClients(autocrawl.FailedClients);
    }
  }, [autocrawl]);
 

  const downloadFiles = async () => {
    try {
      setButtonLoad(true);
      const res = await downloadCanadaAutoCrawledFiles();
      setButtonLoad(false);
    } catch {
      setButtonLoad(false);
    }
  };
 
  // Fetching Invalid Client Credentials
  const getInvalidClientData = async (InvalidClient) => {
  
    try {
      const response = await GetSingleClientCreds({
        vms: InvalidClient.Vms_Name,
        client: InvalidClient.Client_Name,
      });

      if (response) {
        const parsedData = JSON.parse(response);

        // Convert parsedData to array format
        const clientDataArray = Object.entries(parsedData).map(
          ([key, value]) => ({
            id: key,
            value: value,
          })
        );

        setClientData(clientDataArray); // Set array format data
        setModifiedClientData(parsedData); // Set raw data as object for modification
        setSelectedVms(InvalidClient.Vms_Name);
        setInvalidModalVisible(true);
      }
    } catch (error) {
      console.error("Error fetching client data", error);
    }
  };

  // Run the Updated Client API
  const RunUpdatedClient = (Vms_Name) => {
    let Frequency = "Bi-Weekly";
    let User_Id = invalidClients[0].User_Id;
    let Client = [];
    Client.push(ModifiedClientData.Client_Name);

    // Loader Symbol
    setIsCrawling(true);

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}Billing/DownloadForSelectedClients_Billing?VMS=` +
          Vms_Name +
          `&frequency=` +
          Frequency +
          `&userLogin=` +
          User_Id,
        JSON.stringify(Client),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      )
      .then((response) => {
        // Loader Symbol
        // setIsCrawling(false);
        setIsCrawling(false);
        const clientStatus = response.data[0]?.Status; 
  
        // Check if the status is "Report Downloaded"
        if (clientStatus === "Report Downloaded") {
          // Show success message
         SuccessMessage("Report downloaded successfully!");
         const res = dwnldBillingAutocrawl();
         // Immediately remove the client from the invalidClients list
         const updatedInvalidClients = invalidClients.filter(
           (client) => client.Client_Name !== ModifiedClientData.Client_Name
         );
         setInvalidClients(updatedInvalidClients);
         setAutoCrawlData(JSON.parse(res));
       
        } else {
          // Show error message if the status is not "Report Downloaded"
          ErrorMessage(`Failed to download report: ${clientStatus || "Unknown error"}`);
        }
       
      });
  };
  const onUpdateClient = async (Vms_Name) => {
    setInvalidModalVisible(false);

    const Response = await UpdateClientCredential(ModifiedClientData);
    if (Response != null) {
      SuccessMessage(Response.message);
      RunUpdatedClient(Vms_Name);
    }
  };

  const onCancelAutoCrawlModal = () => {
    setFailedModalVisible(false);
  };
  
  const onCancelAutoCrawllModal = () => {
    setInvalidModalVisible(false);
  };
  //OnDataChange
  const altered = {};
  const updatedData = (newData) => {
    newData.map((item) => (altered[item.id] = item.value));
    return altered;
  };

  const onChangeInput = (event, id) => {
    const {
      target: { value },
    } = event;

    const newData = ClientData.map((data) => {
      if (data.id === id) {
        data.value = value;
      }
      return data;
    });
    setClientData(newData); //set updated data for form
    setModifiedClientData(updatedData(newData)); //set data for PUT operation
  };
  const getFailedClientData = async (FailedClient) => {
    try {
      const response = await GetSingleClientCreds({
        vms: FailedClient.Vms_Name,
        client: FailedClient.Client_Name,
      });
  
      if (response) {
        const parsedData = JSON.parse(response);
  
        // Convert parsedData to array format
        const clientDataArray = Object.entries(parsedData).map(([key, value]) => ({
          id: key,
          value: value,
        }));
  
        setClientData(clientDataArray); // Set array format data
        setModifiedClientsData(parsedData); // Set raw data as object for modification
        setSelectedVms(FailedClient.Vms_Name);
        setFailedModalVisible(true);
      }
    } catch (error) {
      console.error("Error fetching failed client data", error);
    }
  };
  const RunUpdatedClients = (Vms_Name) => {
    let Frequency = "Bi-Weekly";
    let User_Id = failedClients[0]?.User_Id; // Safely access failedClients array
    let Client = []; // Simplified client array creation
    Client.push(ModifiedClientsData.Client_Name);
    console.log(failedClients[0])
    // Loader Symbol
    setIsCrawling(true);
  
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}Billing/DownloadForSelectedClients_Billing?VMS=` +
          Vms_Name +
          `&frequency=` +
          Frequency +
          `&userLogin=` +
          User_Id,
        JSON.stringify(Client),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      )
      .then((response) => {
        // Stop loader
        setIsCrawling(false);
  
        // Get the status of the client from the response
        const clientStatus = response.data[0]?.Status;
  
        // Handle success
        if (clientStatus === "Report Downloaded") {
          SuccessMessage("Report downloaded successfully!");
          
         
          // Parse and update auto crawl data
          const res = dwnldBillingAutocrawl();
          const updatedInvalidClients = failedClients.filter(
            (client) => client.Client_Name !== ModifiedClientsData.Client_Name
          );
          setfailedClients(updatedInvalidClients);
          setAutoCrawlData(JSON.parse(res));
        } else {
          // Handle error by showing an error message
          ErrorMessage(`Failed to download report: ${clientStatus || "Unknown error"}`);
        }
      })
      .catch((error) => {
        setIsCrawling(false);
       
      });
  };
  
  
  const onUpdateFailedClient = async (Vms_Name) => {
    setFailedModalVisible(false);
  
    const response = await UpdateClientCredential(ModifiedClientsData);
    if (response != null) {
      // SuccessMessage(response.message);
      RunUpdatedClients(Vms_Name);
    }
  };
  const onChangeInputs = (event, id) => {
    const {
      target: { value },
    } = event;
  
    const newData = ClientData.map((data) => {
      if (data.id === id) {
        data.value = value;
      }
      return data;
    });
    setClientData(newData); 
    setModifiedClientsData(updatedData(newData)); 
  };

  return (
    <>
      <div>
        <div className="vms-processed-div">
          <div>
            <label className="autocrawl-labels">Total VMS Processed :</label>
          </div>
          <div className="processed-div">
            <label className="autocrawl-labels">
              {autocrawl.VmsCompletedCount ? autocrawl.VmsCompletedCount : null}
            </label>
          </div>
        </div>
        {/* <Button type="submit" className="autocrawl-button" onClick={getAutocrawl}>Auto Crawl</Button> */}
        <div className="vms-processed-div">
          <div>
            <label className="autocrawl-labels">Batch Status :</label>
          </div>
          <div className="processed-div">
            <label className="autocrawl-labels">
              {autocrawl.BatchLabel ? autocrawl.BatchLabel : null}
            </label>
          </div>
        </div>
        <Button
          type="submit"
          className="download-reports"
          onClick={downloadFiles}
          loading={buttonLoad}
        >
          <span>Download Auto Crawl Reports</span>
        </Button>
        <div className="failed-client-cards-div">
          {autocrawl.InvalidClients ? (
            autocrawl.InvalidClients.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 150,
                }}
              >
                <Empty
                  description={
                    <span style={{ color: "#003A8C" }}>
                      Hurray! No more invalid clients
                    </span>
                  }
                />
              </div>
            ) : (
              <div className="grid-container">
             
                {invalidClients.map((item, index) => (
                  <Card
                    className="cards-styling"
                    key={`${item.Id}-${index}`} 
                    onClick={() => getInvalidClientData(item)}
                  >
                    <div>
                      <p className="card-heading">
                        <span style={{ fontWeight: "bold" }}>
                          {item.Vms_Name}
                        </span>{" "}
                        | {item.Client_Name}
                      </p>
                      <p className="card-p">{item.Error_Message}</p>
                    </div>
                    <div className="status">
                      {isCrawling &&
                      ModifiedClientData &&
                      ModifiedClientData.Client_Name === item.Client_Name ? (
                        <Spin
                          key={index}
                          size="medium"
                          style={{ marginLeft: "10px" }}
                        />
                      ) : null}
                    </div>
                  </Card>
                ))}
              </div>
            )
          ) : null}

          <Modal
            closable={false}
            open={isInvalidModalVisible}
            okText="Update & Run"
            onOk={() => onUpdateClient(SelectedVms)}
            onCancel={onCancelAutoCrawllModal}
            bodyStyle={{  padding: "20px" }}
          >
            <div>
              {isModalVisibleFlag && ClientData.length === 0 ? (
                "Client Not Found/ Select Client Properly"
              ) : (
                <form>
                  <h2>
                    {
                      ClientData.find((data) => data.id === "Client_Name")
                        ?.value
                    }
                    , {SelectedVms}
                  </h2>
                  {ClientData.filter(
                    (clientObject) =>
                      clientObject.id === "portal_username" ||
                      clientObject.id === "portal_password"
                  ).map((ClientCreds) => (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "10px",
                      }}
                      key={ClientCreds.id}
                    >
                      <label style={{ marginRight: "10px" }}>
                        {ClientCreds.id}:
                      </label>
                      {ClientCreds.id === "portal_password" ? (
                        <Input.Password
                          id={ClientCreds.id}
                          value={ClientCreds.value}
                          onChange={(event) =>
                            onChangeInput(event, ClientCreds.id)
                          }
                        />
                      ) : (
                        <Input
                          id={ClientCreds.id}
                          value={ClientCreds.value}
                          onChange={(event) =>
                            onChangeInput(event, ClientCreds.id)
                          }
                        />
                      )}
                    </div>
                  ))}
                </form>
              )}
            </div>
          </Modal>
        </div>

        <div className="failed-client-cards-div">
  {autocrawlData.FailedClients && autocrawlData.FailedClients.length === 0 ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 150,
      }}
    >
      <Empty
        description={
          <span style={{ color: "#003A8C" }}>Hurray! No more failed clients</span>
        }
      />
    </div>
  ) : (
    <div>
      <label className="autocrawl-labels">Failed Clients :</label>
      <div className="grid-container">
        {failedClients.map((item, index) => (
          <Card
            className="cards-styling"
            key={`${item.Id}-${index}`} 
            // onClick={() => getFailedClientData(item)}
          >
            <div>
              <p className="card-heading">
                <strong>{item.Vms_Name}</strong> | {item.Client_Name}
              </p>
              {isCrawling &&
                      ModifiedClientsData &&
                      ModifiedClientsData.Client_Name === item.Client_Name ? (
                        <Spin
                          key={index}
                          size="medium"
                          style={{ marginLeft: "10px" }}
                        />
                      ) : null}
             
              
            </div>
            <div className="status">
                      {isCrawling &&
                      ModifiedClientData &&
                      ModifiedClientData.Client_Name === item.Client_Name ? (
                        <Spin
                          key={index}
                          size="medium"
                          style={{ marginLeft: "10px" }}
                        />
                      ) : null}
                    </div>
          </Card>
        ))}
      </div>
    </div>
  )}

  <Modal
    closable={false}
    open={isFailedModalVisible}
    okText="ReRun"
    onOk={() => onUpdateFailedClient(SelectedVms)}
    onCancel={onCancelAutoCrawlModal}
    bodyStyle={{  padding: "20px" }}
  >
    <div>
      {isModalVisibleFlag && ClientData.length === 0 ? (
        "Client Not Found/ Select Client Properly"
      ) : (
        <form>
          <h2>
            {ClientData.find((data) => data.id === "Client_Name")?.value}, {SelectedVms}
          </h2>
          {ClientData.filter(
            (clientObject) =>
              clientObject.id === "portal_username" ||
              clientObject.id === "portal_password"
          ).map((ClientCreds) => (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
              }}
              key={ClientCreds.id}
            >
              <label style={{ marginRight: "10px" }}>{ClientCreds.id}:</label>
              {ClientCreds.id === "portal_password" ? (
                <Input.Password
                  id={ClientCreds.id}
                  value={ClientCreds.value}
                  onChange={(event) => onChangeInputs(event, ClientCreds.id)}
                />
              ) : (
                <Input
                  id={ClientCreds.id}
                  value={ClientCreds.value}
                  onChange={(event) => onChangeInputs(event, ClientCreds.id)}
                />
              )}
            </div>
          ))}
        </form>
      )}
    </div>
  </Modal>
</div>


        {/* <div className="mfdwnl-div">
          <Button
            type="submit"
            className="consolidate-but"
            onClick={downloadMSfile}
            loading={loader}
          >
            Download masterfile
          </Button> */}
      </div>
      {/* </div> */}
    </>
  );
};
export default AutocrawlCanada_Section;
